import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const STREAM_URL = `${API}/stream`;

export const fmtTime = (s) => {
  if (!s || s < 0) s = 0;
  const m = Math.floor(s / 60);
  return `${m}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
};

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";

export function useStudioApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, path, data, extra = {}) => {
    const token = await getToken();
    const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` }, ...extra });
    return res.data;
  }, [getToken]);
}
